import React from 'react';
import { 
  HelpCircle, 
  ThermometerSun, 
  Zap, 
  Droplet, 
  Car, 
  ArrowUpDown, 
  Gauge,
  Wind 
} from 'lucide-react';

const FuelTipsSidebar = () => {
  const tips = [
    {
      icon: Gauge,
      title: 'Контроль скорости',
      description: 'Оптимальная скорость 60-90 км/ч. При скорости выше 110 км/ч аэродинамическое сопротивление значительно увеличивается.'
    },
    {
      icon: ThermometerSun,
      title: 'Оптимальное давление',
      description: 'Регулярно проверяйте давление в шинах. Снижение давления на 25% увеличивает расход топлива на 3-5%.'
    },
    {
      icon: Zap,
      title: 'Плавное ускорение',
      description: 'Избегайте резких разгонов. Плавное ускорение может снизить расход топлива до 15%.'
    },
    {
      icon: Wind,
      title: 'Кондиционер',
      description: 'На трассе закрытые окна и кондиционер экономичнее открытых окон. В городе открытые окна лучше постоянно работающего кондиционера.'
    },
    {
      icon: ArrowUpDown,
      title: 'Оптимальные передачи',
      description: 'Переключайтесь на повышенную передачу как можно раньше. Оптимальные обороты 2000-2500 для бензина и 1500-2000 для дизеля.'
    },
    {
      icon: Car,
      title: 'Лишний вес',
      description: 'Регулярно очищайте багажник от лишних вещей. Каждые 50 кг дополнительного веса увеличивают расход топлива примерно на 2%.'
    },
    {
      icon: Droplet,
      title: 'Качество топлива',
      description: 'Используйте качественное топливо от проверенных АЗС. Некачественное топливо может увеличить расход и снизить ресурс двигателя.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-blue-500" />
        Советы по экономии топлива
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <Zap className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Знаете ли вы?
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              В России можно экономить до 30% топлива за счет правильного вождения и обслуживания автомобиля. При среднегодовом пробеге 15,000 км и расходе 10 л/100 км это позволит сэкономить около 24,000 ₽ в год.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FuelTipsSidebar;